import React from 'react'
import FirmDashboardViewModel from './FirmDashboardViewModel'
import { useDocumentTitle } from '../../../hooks/document-title'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
  StickyViewHeaderSpacer,
} from 'components/StickyViewHeader'
import FirmDashboardViewHeading from './FirmDashboardViewHeading'
import { useActivation } from 'hooks/mobx-hooks'
import FirmDashboardJobsViewer, {
  FirmDashboardJobCount,
} from './FirmDashboardJobsViewer'
import styles from './FirmDashboard.sass'
import FirmDashboardJobsViewerHeader from './FirmDashboardJobsViewerHeader'
import FirmDashboardQuickSelectFilter from './FirmDashboardQuickSelectFilter'
import FirmDashboardOverviewSidebar from './FirmDashboardOverviewSidebar'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import { observer } from 'mobx-react'
import ContentError from 'components/ContentError'
import ContentLoading from 'components/ContentLoading'

interface FirmDashboardProps {
  vm: FirmDashboardViewModel
}

export default observer(function FirmDashboard({ vm }: FirmDashboardProps) {
  useDocumentTitle('Dashboard')
  useActivation(vm)

  return vm.activate.match({
    pending: () => <ContentLoading />,
    rejected: (err) => <ContentError error={err} />,
    resolved: () => <FirmDashboardContent vm={vm} />,
  })
})

const FirmDashboardContent = observer(function FirmDashboardContent({
  vm,
}: FirmDashboardProps) {
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)

  return (
    <div ref={scrollRef} className={styles.root}>
      <StickyViewHeader scrollOffset={scrollOffset}>
        <StickyViewHeaderMain>
          <FirmDashboardViewHeading vm={vm} />
        </StickyViewHeaderMain>
        <StickyViewHeaderSpacer />
      </StickyViewHeader>

      <div className={styles.container}>
        <div className={styles.overviewSidebarContainer}>
          <FirmDashboardOverviewSidebar vm={vm.overviewSidebarViewModel} />
        </div>

        <div className={styles.mainContent}>
          <div className={styles.quickSelectFilterContainer}>
            <FirmDashboardQuickSelectFilter
              filter={vm.firmDashboardJobTableViewModel.statusFilter}
              vm={vm.quickSelectFilterViewModel}
            />
          </div>

          <FirmDashboardJobCount vm={vm.firmDashboardJobTableViewModel} />

          <div className={styles.jobsTableHeader}>
            <FirmDashboardJobsViewerHeader
              vm={vm.firmDashboardJobTableViewModel}
            />
          </div>

          <div className={styles.jobsTable}>
            <FirmDashboardJobsViewer vm={vm.firmDashboardJobTableViewModel} />
          </div>
        </div>
      </div>
    </div>
  )
})
